import * as React from "react";
import type { SVGProps } from "react";
const SvgLogoMaze = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 143 48"
    {...props}
  >
    <g
      fill="currentColor"
      clipPath="url(#Logo_Maze_svg__a)"
    >
      <path
        fillRule="evenodd"
        d="M3.054 35.852a8.207 8.207 0 0 1 0-11.676l8.832-8.758c2.75-2.725 6.942-3.147 10.138-1.264.988.582.98 1.918.167 2.724s-2.14.736-3.244.416a4.19 4.19 0 0 0-4.116 1.043l-8.833 8.758a4.104 4.104 0 0 0 0 5.838 4.19 4.19 0 0 0 5.888 0l17.665-17.515c3.252-3.224 8.524-3.224 11.777 0l8.832 8.758a8.207 8.207 0 0 1 0 11.676c-3.252 3.224-8.524 3.224-11.776 0l-2.945-2.92-3.68 3.65c-2.749 2.725-6.942 3.147-10.137 1.264-.989-.582-.98-1.918-.167-2.724s2.14-.737 3.243-.416a4.19 4.19 0 0 0 4.117-1.043L32.6 29.91a4.04 4.04 0 0 1 5.678 0l3.05 3.023a4.19 4.19 0 0 0 5.888 0 4.103 4.103 0 0 0 0-5.838l-8.833-8.757a4.19 4.19 0 0 0-5.888 0L14.83 35.852c-3.252 3.224-8.524 3.224-11.776 0"
        clipRule="evenodd"
      />
      <path
        d="M85.86 17.68c-2.046 0-3.597.732-4.62 2.198-.899-1.466-2.325-2.198-4.216-2.198-1.953 0-3.38.671-4.31 2.045v-1.618h-4v15.265h4v-8.579c0-2.229 1.147-3.45 2.915-3.45 1.643 0 2.604 1.069 2.604 2.9v9.13h4v-8.58c0-2.229 1.054-3.45 2.883-3.45 1.643 0 2.604 1.069 2.604 2.9v9.13h4v-9.404c0-3.817-2.295-6.29-5.86-6.29M106.588 19.908c-1.209-1.496-2.884-2.228-5.054-2.228-2.077 0-3.844.793-5.333 2.35-1.457 1.557-2.2 3.45-2.2 5.71s.743 4.182 2.2 5.74c1.489 1.556 3.256 2.32 5.333 2.32 2.17 0 3.845-.733 5.054-2.23v1.802h3.999V18.107h-3.999zm-7.38 8.946Q98 27.617 98 25.74c0-1.252.403-2.29 1.209-3.084.806-.824 1.829-1.221 3.069-1.221s2.263.397 3.07 1.221c.837.794 1.24 1.832 1.24 3.084 0 1.251-.403 2.29-1.24 3.114q-1.21 1.19-3.07 1.19t-3.07-1.19M125.344 20.733v-2.626h-11.626V21.8h6.231l-6.542 8.946v2.625h12.247v-3.694h-6.883zM142.377 27.358c.093-.58.155-1.1.155-1.618 0-2.29-.744-4.183-2.232-5.74-1.457-1.557-3.349-2.32-5.612-2.32-2.387 0-4.371.763-5.891 2.32-1.519 1.526-2.294 3.45-2.294 5.74q0 3.48 2.326 5.77c1.55 1.526 3.596 2.29 6.169 2.29 2.976 0 5.24-1.1 6.759-3.267l-3.224-1.832c-.776 1.008-1.953 1.526-3.473 1.526-2.387 0-3.844-.946-4.371-2.87zm-11.75-3.053c.465-1.954 1.922-3.084 4.061-3.084 1.829 0 3.379 1.008 3.845 3.084z" />
    </g>
    <defs>
      <clipPath id="Logo_Maze_svg__a">
        <path
          fill="#fff"
          d="M.615 0h142v48h-142z"
        />
      </clipPath>
    </defs>
  </svg>
);
export default SvgLogoMaze;
